import API_BASE_URL from "./api";

const checkLogin = async () => {

    try {

        const response = await fetch(
            `${API_BASE_URL}/admin/me`,
            {
                method: "GET",

                headers: {
                    "Accept": "application/json"
                },

                credentials: "include"
            }
        );


        if (response.status === 401) {

            return false;

        }


        if (!response.ok) {

            return false;

        }


        const data =
            await response.json();


        return !!data.admin;


    } catch (error) {

        console.error(
            "CHECK LOGIN ERROR:",
            error
        );

        return false;

    }

};


export default checkLogin;